import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';

import * as Services from '@shared/core/services';
import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

import { ModalViewComponent } from '../modal-view.shared.component';

import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'shared-modal-for-menu-flow',
    templateUrl: './modal-for-menu-flow.shared.component.html',
    styleUrls: ['./modal-for-menu-flow.shared.component.scss']
})
export class ModalForMenuFlowComponent extends ModalViewComponent implements OnInit, AfterViewInit, OnDestroy {
    public menuFlow$: Observable<State.IWizzardMenuFlow>; /* Consumer -> shared-vcard */
    public menuFlowPagesFiltered$: Observable<State.IWizzardMenuFlowPage[]>;
    public menuFlowImage$: Observable<string>;
    public imageLoading$: Observable<boolean>;
    public menuFlowStats$: Observable<OLO.Components.IStatsComponentInput>; /* Consumer -> shared-vcard */
    public menuFlowQuantity$: Observable<number>; /* Consumer -> shared-quantity */
    public menuFlowTotalValue$: Observable<number>; /* Consumer -> shared-modal-item-actions */
    public menuFlowUnitPrice$: Observable<number>; /* Consumer -> none */
    public menuFlowTagImages$: Observable<State.IDietaryTagImage[]>; /* Consumer -> shared-vcard */
    public menuFlowTitle$: Observable<string>; /* Consumer -> shared-vcard */
    public menuFlowDescription$: Observable<string>; /* Consumer -> shared-vcard */
    public menuFlowTotalSelectedProducts$: Observable<number>; /* Consumer -> shared-modal-item-actions */
    public menuFlowAcceptBtnLabel$: Observable<string>; /* Consumer -> shared-modal-item-actions */
    public menuFlowAcceptBtnLabelPrice$: Observable<number>; /* Consumer -> shared-modal-item-actions */
    public canUseCTAButton$: Observable<boolean>;

    public scrollCurrentActivePageIdentifier$: Observable<number>; /* Consumer -> wizzard-sub-nav */
    public scrollDuration: number = 200;

    public wizzardErrorsListener$: Subscription;
    public wizzardStepThroughElementsListener$: Subscription; /* Data intercepted from step-through page - tells which page has just collapsed - so you can scroll to this page */

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public controllers: Controllers,
        public menuFlowPagesService: Services.MenuFlowPagesService,
        public wizzardService: Services.WizzardService,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.menuFlow$ = this.controllers.wizzard.wizzardMenuFlow$();
        this.menuFlowPagesFiltered$ = this.controllers.wizzard.getWizzardMenuFlowPages$();
        this.menuFlowImage$ = this.controllers.wizzard.wizzardMenuFlowImage$();
        this.imageLoading$ = this.controllers.wizzard.wizzardItemImageLoading$();
        this.menuFlowQuantity$ = this.controllers.wizzard.wizzardMenuFlowQuantity$();
        this.menuFlowUnitPrice$ = this.controllers.wizzard.wizzardMenuFlowUnitPrice$();
        this.menuFlowTotalValue$ = this.controllers.wizzard.wizzardMenuFlowTotalValue$();
        this.menuFlowStats$ = this.controllers.wizzard.wizzardMenuFlowStats$('From ');
        this.menuFlowTagImages$ = this.controllers.wizzard.wizzardMenuFlowTagsImages$();
        this.menuFlowTitle$ = this.controllers.wizzard.wizzardMenuFlowTitle$();
        this.menuFlowDescription$ = this.controllers.wizzard.wizzardMenuFlowDescription$();
        this.menuFlowTotalSelectedProducts$ = this.controllers.wizzard.wizzardMenuFlowTotalSelectedProducts$();
        this.menuFlowAcceptBtnLabel$ = this.controllers.wizzard.wizzardAcceptBtnLabel$();
        this.menuFlowAcceptBtnLabelPrice$ = this.controllers.wizzard.wizzardAcceptBtnLabelPrice$();
        this.canUseCTAButton$ = this.controllers.wizzard.canAddWizzardMenuFlowToCart$();

        this.scrollCurrentActivePageIdentifier$ = this.menuFlowPagesService.currentActivePageIdentifier$;

        const type: State.MODAL_TYPE = this.modalData.type;

        /* CTA button */
        if (type === 'upsell') {
            this.showButtonPrice = false;

        }

        /* Icon */
        if (type === 'enhanced-menu-flow') {
            this.iconInsteadOfImage = true;
        }

        /* Size & feel */
        this.size = 'lg';
        this.dimmedBg = true;
        this.shadow = true;

        if (type === 'enhanced-menu-flow') {
            this.showSubHeader = true;
        }
    }

    ngAfterViewInit(): void {
        /* Setup scroll error listener */
        if (this.menuFlowPagesService) {
            this.wizzardErrorsListener$ = this.controllers.wizzard.getMenuFlowPageIdentifierOneNewError$()
                .subscribe(this.handleSubscribeScrollError.bind(this));

            this.wizzardStepThroughElementsListener$ = this.wizzardService.nextStepThroughState$
                .subscribe(this.handleSubscribeCollapsedElement.bind(this));
        }

        if (this.showSubHeader) {
            this.menuFlowPagesService.calculateCurrentScrolledPage(this.scrollParentContainer);
        }
    }

    ngOnDestroy(): void {
        if (this.wizzardErrorsListener$ && !this.wizzardErrorsListener$.closed) this.wizzardErrorsListener$.unsubscribe();
        if (this.wizzardStepThroughElementsListener$ && !this.wizzardStepThroughElementsListener$.closed) this.wizzardStepThroughElementsListener$.unsubscribe();

        if (this.showSubHeader) {
            this.menuFlowPagesService.unsetCurrentScrolledPage();
        }
    }

    public handleMenuFlowIncrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        this.controllers.wizzard.wizzardMenuFlowIncrement();
    }

    public handleMenuFlowDecrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        this.controllers.wizzard.wizzardMenuFlowDecrement();
    }

    public handleMenuFlowRemove($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        this.controllers.wizzard.wizzardMenuFlowDecrement();
    }

    public handleMenuFlowCtaClick($event: Event): void {
        this.controllers.wizzard.wizzardMenuFlowCTAButtonClick(this.modalData);
    }


    public handleSubscribeScrollError(pageIdentifier: number): void {
        //
        //  When error occurs, scroll to error
        //
        if (this.scrollParentContainer && pageIdentifier) {
            this.menuFlowPagesService.scrollToMenuFlowPage(this.scrollParentContainer, pageIdentifier, this.scrollDuration);
        }
    }

    public handleSubscribeCollapsedElement(nextState: OLO.Components.IWizzardStepThroughNextStateDetails): void {
        //
        //  When element collapses/expands - scroll to it - step-through-menuflow
        //
        const scrollContainer = this.heightAdjustService.getEntry(`modal-${this.modalData.id}`)?.source;
        if (this.scrollParentContainer && nextState && scrollContainer) {
            setTimeout(() => {
                const parent = scrollContainer.parentElement;
                const totalScroll = parent.scrollHeight;
                const diffToScrollBack = totalScroll - scrollContainer.clientHeight;

                let compensation = -30;
                if (diffToScrollBack && nextState.isLast && !nextState.isExpanded) {
                    // compensation = -1 *(diffToScrollBack - 200);

                    parent.scrollTo(0, 0);

                    return;
                }
                this.menuFlowPagesService.scrollToMenuFlowPage(this.scrollParentContainer, nextState.menuFlowPage.PageIdentifier, this.scrollDuration, compensation);
            }, 200);

        }
    }

    /* Scrolling events */

    public handleScrollY($event: HTMLElement): void {
        //
        //  Update current active page id on each scroll
        //
        if (this.showSubHeader) {
            this.menuFlowPagesService.calculateCurrentScrolledPage(this.scrollParentContainer);
        }

        //
        //  Handle collapse header on scroll
        //
        const scrollPos: number = this.scrollParentContainer.scrollTop;
        if (scrollPos >= 300 && this.collapseHeader === false) {
            this.collapseHeader = true;
        }
        if (scrollPos < 300 && this.collapseHeader === true) {
            this.collapseHeader = false;
        }
    }

    public handleSubNavClick(pageIdentifier: number): void {
        this.menuFlowPagesService.scrollToMenuFlowPage(this.scrollParentContainer, pageIdentifier, this.scrollDuration);
    }
}
